import React from "react";

export const HtmlItemNode = (props) => {
  return <div dangerouslySetInnerHTML={{ __html: props.content }} />;
};
